<template>
    <div style="display: flex; flex-direction: column; gap: 10px; position: relative"> 
        <CameraModule v-if="model" @update="cameraEvt" @start="startEvt" :blue="blue" :purple="purple"/>
        <canvas ref="canvas" width="224" height="224" class="layer" style="" />
    </div>
</template>

<script>
import CameraModule from '@/tm/Camera'
import Camera from '@/tm/Camera/scripts/camera.js';
import CustomTmPose from '@/utils/src/CustomTmPose';

export default {
    name: 'PoseModel',
    emits: ['result', 'start'],
    props:{
        blue: {
            type: Boolean,
            default: false,
        },
        purple: {
            type: Boolean,
            default: false,
        },
        model: {
            type: Object,
            default: new CustomTmPose()
        },
        slow: {
            type: Number,
            default: 0
        }
    },
    components: {
        CameraModule
    },
    data(){
        return {
            slowCounter: 0,
            isFinish: true
        }
    },
    methods: {
        startEvt(){
            this.$emit('start')
        }, 
        async cameraEvt(canvas){
            if (!this.model || !this.model.model) {
                return
            }
            if (this.slow) {
                if (this.slowCounter < this.slow) {
                    this.slowCounter++
                    return 
                } else {
                    this.slowCounter = 0;
                }
            }
            const {result} = await this.model.predict(canvas, this.$refs.canvas)
            if (result) {
                this.$emit('result', result, canvas)
            }
        },
    },
    mounted(){
        /* this.test(); */
    }
}
</script>

<style scoped>
.layer{
    position: absolute; 
    bottom: 0;
    width: 240px; height: 240px;
    pointer-events: none;

}
</style>